import { AxiosRequestConfig } from 'axios';

import ApiClient, { ApiOptions } from 'lib/clients/ApiClient';

export const API_ROOT_ONBOARD = '/api/internal/onboard/v1';

class Client extends ApiClient {
  // Used to set Persona-Country header to route requests to our servers in that country
  private countryToRouteRequests?: string;

  public get personaCountry() {
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    return this.countryToRouteRequests;
  }

  public set personaCountry(countryToRouteRequests: string) {
    this.countryToRouteRequests = countryToRouteRequests;
  }

  protected async sendRequest(
    uri: string,
    requestOptions: AxiosRequestConfig,
    options: ApiOptions = {},
  ) {
    const requestOptionsWithHeaders = {
      ...requestOptions,
      headers: {
        ...requestOptions.headers,
        'Persona-Country': this.countryToRouteRequests,
      },
    };

    const response = await super.sendRequest(uri, requestOptionsWithHeaders, options);

    // NOTE: Axios coerces all response headers to be lowercase
    // Send subsequent requests to servers in country determined by backend.
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    if (response.headers?.['persona-country']) {
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      this.countryToRouteRequests = response.headers['persona-country'];
    }

    return response;
  }
}

export default new Client(API_ROOT_ONBOARD);
